import React from 'react';
import { Activity, Beaker, Leaf } from 'lucide-react';
export function ScienceSection() {
  const points = [{
    icon: <Activity className="w-5 h-5 text-gold" data-id="element-501" />,
    title: 'Ritual Fisiológico',
    desc: 'Activá el Nervio Vago para reducir el cortisol en minutos. El estrés crónico no solo te pone de mal humor, literalmente apaga tu digestión. Aprenderás la técnica de activación que enciende el "modo digestivo" de tu sistema nervioso. Resultado: menos gases, menos hinchazón y más calma en una sola práctica diaria.'
  }, {
    icon: <Beaker className="w-5 h-5 text-gold" data-id="element-502" />,
    title: 'Estudio de Stanford 2021',
    desc: 'Los fermentados superan a la fibra para reducir la inflamación sistémica. No es opinión, es el hallazgo más importante de la ciencia digestiva en los últimos 10 años. Te mostramos exactamente qué fermentados usar, cuándo tomarlos y cómo prepararlos en casa para que tu microbiota trabaje para vos.'
  }, {
    icon: <Leaf className="w-5 h-5 text-gold" data-id="element-503" />,
    title: 'La Ciencia de las 12 Hierbas',
    desc: 'Compuestos naturales que bloquean el NF-kB, el interruptor maestro de la inflamación. Estas 12 hierbas apagan la inflamación de forma natural, actuando como un ibuprofeno biológico sin efectos secundarios. Disponibles en cualquier supermercado o dietética de tu barrio.'
  }];
  return <section className="py-14 bg-sage text-cream" data-id="element-504">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-505">
        <div className="max-w-4xl mx-auto text-center mb-10" data-id="element-506">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 text-white" data-id="element-507">
            Más que una dieta, un Biohacking para tu Microbiota.
          </h2>
          <p className="text-xl text-cream/80 font-sans" data-id="element-508">
            Basado en ciencia real para mujeres reales.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-509">
          {points.map((point, idx) => <div key={idx} className="bg-cream rounded-2xl p-6 border border-gold/20 shadow-xl hover:-translate-y-1 transition-transform duration-300" data-id="element-510">
              <div className="bg-sage/5 w-10 h-10 rounded-full flex items-center justify-center mb-4 border border-sage/10" data-id="element-511">
                {point.icon}
              </div>
              <h3 className="text-lg font-serif font-bold text-sage mb-2" data-id="element-512">
                {point.title}
              </h3>
              <p className="text-sage/80 leading-snug text-sm" data-id="element-513">{point.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}